import { render, staticRenderFns } from "./DialogAddReport.vue?vue&type=template&id=2154ac4d&scoped=true"
import script from "./DialogAddReport.vue?vue&type=script&lang=js"
export * from "./DialogAddReport.vue?vue&type=script&lang=js"
import style0 from "./DialogAddReport.vue?vue&type=style&index=0&id=2154ac4d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2154ac4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2154ac4d')) {
      api.createRecord('2154ac4d', component.options)
    } else {
      api.reload('2154ac4d', component.options)
    }
    module.hot.accept("./DialogAddReport.vue?vue&type=template&id=2154ac4d&scoped=true", function () {
      api.rerender('2154ac4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddReport.vue"
export default component.exports